/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

export const JiraRequestsGet = {
  id: 'jira-requests.get',
  tag: 'Support',
  summary: 'Jira get all requests',
  description: 'Get all Jira requests',
  method: 'get',
  flags: { isAuthorized: true },
  route: () => `/jira/requests`,
  request: {
    query: z.strictObject({
      requestStatus: z.enum(['open', 'closed', 'all']),
      take: z.coerce.number(),
      skip: z.coerce.number(),
    }),
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.array(
            z.strictObject({
              issueId: z.string(),
              issueKey: z.string(),
              requestTypeId: z.string().optional(),
              serviceDeskId: z.string().optional(),
              summary: z.string(),
              description: z.string().optional(),
              createdAt: z.string(),
              status: z.strictObject({
                name: z.string(),
                category: z.string(),
              }),
              // Do no use `.strictObject` here
              metaData: z.object({
                'User ID': ZodTypes.Id,
                'Support Plan': z.string().optional(),
                'Organization ID': z.string().optional(),
                'Project ID': z.string().optional(),
                Namespace: z.string().optional(),
                'Customer ID': z.string().optional(),
                'Cluster ID': z.string().optional(),
                'Cluster Name': z.string().optional(),
              }),
            }),
          ),
        },
      },
    },
  },
} as const satisfies Endpoint;
